import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, first, map, withLatestFrom } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';

import { RootState } from '@root/app.state';
import * as PlatformActions from '@platform/platform.actions';
import { selectDialog } from '@platform/platform.selectors';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private store$: Store<RootState>) {}

  public openDialog<TResult extends any>(
    componentOrTemplateRef: ComponentType<any> | TemplateRef<any>,
    config?: MatDialogConfig,
  ): Observable<TResult> {
    const dialogId = uuid();
    this.store$.dispatch(
      PlatformActions.openDialog({
        componentOrTemplateRef,
        config: {
          ...config,
          id: dialogId,
        },
      }),
    );

    return this.store$.pipe(
      select(selectDialog),
      withLatestFrom(of(dialogId)), // make sure the value is still available after the method finished
      map(([state, id]) => state.dialogs.find((d) => d.id === id)),
      filter((dialog) => !!dialog && !dialog.isOpen),
      distinctUntilChanged(),
      map((dialog) => dialog!.data),
      first(), // close the observable after the dialog has been closed
    );
  }
}
